import React, { Component } from "react";

import Tooltip from "../tooltip";
import BlockSelectionAddCustom from "./blockSelectionAddCustom/blockSelectionAddCustom";
import BlockImage from "./blockImage";

import MapModes from "./json/mapModes.json";
import SupportedVersions from "./json/supportedVersions.json";

import "./blockSelection.css";

class BlockSelection extends Component {
  state = {
    lastSelectedCustomBlock: null, // {colourSetId, blockId}
  };

  cssRGB(RGBArray) {
    // RGB array to css compatible string
    return `rgb(${RGBArray.join(", ")})`;
  }









  getColourSetBox = (colourSet) => {
    const { optionValue_staircasing } = this.props;
    let background;
    switch (optionValue_staircasing) {
      case MapModes.SCHEMATIC_NBT.staircaseModes.OFF.uniqueId:
      case MapModes.MAPDAT.staircaseModes.OFF.uniqueId: {
        background = this.cssRGB(colourSet.tonesRGB.normal);
        break;
      }
      case MapModes.SCHEMATIC_NBT.staircaseModes.CLASSIC.uniqueId:
      case MapModes.SCHEMATIC_NBT.staircaseModes.VALLEY.uniqueId:
      case MapModes.MAPDAT.staircaseModes.ON.uniqueId: {
        background = `linear-gradient(${this.cssRGB(colourSet.tonesRGB.dark)} 33%, ${this.cssRGB(colourSet.tonesRGB.normal)} 33%, ${this.cssRGB(
          colourSet.tonesRGB.normal
        )} 66%, ${this.cssRGB(colourSet.tonesRGB.light)} 66%)`;
        break;
      }
      case MapModes.MAPDAT.staircaseModes.ON_UNOBTAINABLE.uniqueId: {
        background = `linear-gradient(${this.cssRGB(colourSet.tonesRGB.unobtainable)} 25%, ${this.cssRGB(colourSet.tonesRGB.dark)} 25%, ${this.cssRGB(
          colourSet.tonesRGB.dark
        )} 50%, ${this.cssRGB(colourSet.tonesRGB.normal)} 50%, ${this.cssRGB(colourSet.tonesRGB.normal)} 75%, ${this.cssRGB(colourSet.tonesRGB.light)} 75%)`;
        break;
      }
      case MapModes.SCHEMATIC_NBT.staircaseModes.FULL_DARK.uniqueId:
      case MapModes.MAPDAT.staircaseModes.FULL_DARK.uniqueId: {
        background = this.cssRGB(colourSet.tonesRGB.dark);
        break;
      }
      case MapModes.SCHEMATIC_NBT.staircaseModes.FULL_LIGHT.uniqueId:
      case MapModes.MAPDAT.staircaseModes.FULL_LIGHT.uniqueId: {
        background = this.cssRGB(colourSet.tonesRGB.light);
        break;
      }
      case MapModes.MAPDAT.staircaseModes.FULL_UNOBTAINABLE.uniqueId: {
        background = this.cssRGB(colourSet.tonesRGB.unobtainable);
        break;
      }
      default: {
        throw new Error("Unknown staircasing value");
      }
    }
    return (
      <div
        className="colourSetBox"
        style={{
          background: background,
        }}
      />
    );
  };

  getColourSetTones = (colourSetId, colourSet, disabledTones, onToggleColourTone) => {
    const { optionValue_staircasing } = this.props;
    switch (optionValue_staircasing) {
      case MapModes.SCHEMATIC_NBT.staircaseModes.CLASSIC.uniqueId:
      case MapModes.SCHEMATIC_NBT.staircaseModes.VALLEY.uniqueId:
        return (
          <React.Fragment>
            <Tooltip tooltipText="DARK SHADE">
              <div className="colourSetToneWrapper" onClick={() => onToggleColourTone(colourSetId, "dark")}>
                <div
                  className="colourSetBox"
                  style={{
                    background: this.cssRGB(colourSet.tonesRGB.dark),
                    cursor: "pointer",
                  }}
                />
                {!disabledTones[colourSetId].has("dark") && <div className="selectionLine" />}
              </div>
            </Tooltip>
            <Tooltip tooltipText="NORMAL SHADE">
              <div className="colourSetToneWrapper" onClick={() => onToggleColourTone(colourSetId, "normal")}>
                <div
                  className="colourSetBox"
                  style={{
                    background: this.cssRGB(colourSet.tonesRGB.normal),
                    cursor: "pointer",
                  }}
                />
                {!disabledTones[colourSetId].has("normal") && <div className="selectionLine" />}
              </div>
            </Tooltip>
            <Tooltip tooltipText="BRIGHT SHADE">
              <div className="colourSetToneWrapper" onClick={() => onToggleColourTone(colourSetId, "light")}>
                <div
                  className="colourSetBox"
                  style={{
                    background: this.cssRGB(colourSet.tonesRGB.light),
                    cursor: "pointer",
                  }}
                />
                {!disabledTones[colourSetId].has("light") && <div className="selectionLine" />}
              </div>
            </Tooltip>
          </React.Fragment>
        );
      default:
        return "";
    }
  };

  render() {
    const {
      coloursJSON,
      getLocaleString,
      onChangeColourSetBlock,
      onToggleColourTone,
      optionValue_version,
      selectedBlocks,
      disabledTones,
      presets,
      selectedPresetName,
      canDeletePreset,
      onPresetChange,
      onDeletePreset,
      onSavePreset,
      onExportPreset,
      onImportPreset,
      onGetPDNPaletteClicked,
      onGenerateColorScheme,
      handleAddCustomBlock,
      handleDeleteCustomBlock,
    } = this.props;
    const { lastSelectedCustomBlock } = this.state;
    const presetsManagement = (
      <React.Fragment>
        <h2 id="blockselectiontitle">{getLocaleString("BLOCK-SELECTION/TITLE")}</h2>
        <b>
          {getLocaleString("BLOCK-SELECTION/PRESETS/TITLE")}
          {":"}
        </b>{" "}
        <select id="presets" value={selectedPresetName} onChange={onPresetChange}>
          <option value="None">{getLocaleString("BLOCK-SELECTION/PRESETS/NONE")}</option>
          {presets.map((preset) => (
            <option value={preset.name} key={preset.name}>
              {"localeKey" in preset ? getLocaleString(preset.localeKey) : preset.name}
            </option>
          ))}
        </select>
        <button type="button" disabled={!canDeletePreset()} onClick={onDeletePreset}>
          {getLocaleString("BLOCK-SELECTION/PRESETS/DELETE")}
        </button>
        <button type="button" onClick={onSavePreset}>
          {getLocaleString("BLOCK-SELECTION/PRESETS/SAVE")}
        </button>
        <Tooltip tooltipText={getLocaleString("BLOCK-SELECTION/PRESETS/EXPORT-TT")}>
          <button type="button" onClick={onExportPreset}>
            {getLocaleString("BLOCK-SELECTION/PRESETS/EXPORT")}
          </button>
        </Tooltip>
        <Tooltip tooltipText={getLocaleString("BLOCK-SELECTION/PRESETS/IMPORT-TT")}>
          <button type="button" onClick={onImportPreset}>
            {getLocaleString("BLOCK-SELECTION/PRESETS/IMPORT")}
          </button>
        </Tooltip>
        <Tooltip tooltipText={getLocaleString("BLOCK-SELECTION/PRESETS/DOWNLOAD-TT")}>
          <button type="button" onClick={onGetPDNPaletteClicked}>
            {getLocaleString("BLOCK-SELECTION/PRESETS/DOWNLOAD")}
          </button>
        </Tooltip>
        <Tooltip tooltipText={getLocaleString("BLOCK-SELECTION/PRESETS/COLOR-SCHEME-TT")}>
          <button type="button" onClick={onGenerateColorScheme}>
            {getLocaleString("BLOCK-SELECTION/PRESETS/COLOR-SCHEME")}
          </button>
        </Tooltip>
      </React.Fragment>
    );
    const blockSelection = (
      <React.Fragment>
        {Object.entries(coloursJSON)
          .filter(([, colourSet]) => Object.values(colourSet.blocks).some((block) => Object.keys(block.validVersions).includes(optionValue_version.MCVersion)))
          .map(([colourSetId, colourSet]) => (
            <div key={colourSetId} className="colourSet">
              {this.getColourSetBox(colourSet)}
              {this.getColourSetTones(colourSetId, colourSet, disabledTones, onToggleColourTone)}
              <label>
                <Tooltip tooltipText={getLocaleString("NONE")}>
                  <div className="blockWithIndicator">
                    <BlockImage
                      getLocaleString={getLocaleString}
                      coloursJSON={coloursJSON}
                      colourSetId={colourSetId}
                      blockId={"-1"}
                      onClick={() => onChangeColourSetBlock(colourSetId, "-1")}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    {selectedBlocks[colourSetId] === "-1" && <div className="selectionLine" />}
                  </div>
                </Tooltip>
              </label>
              <div className={"colourSetBlocks"}>
                {Object.entries(colourSet.blocks)
                  .filter(([, block]) => Object.keys(block.validVersions).includes(optionValue_version.MCVersion))
                  .map(([blockId, block]) => (
                    <label key={blockId}>
                      <Tooltip tooltipText={block.displayName}>
                        {selectedBlocks[colourSetId] === blockId &&
                          !(Object.values(SupportedVersions)[Object.keys(SupportedVersions).length - 1].MCVersion in block.validVersions) && (
                            // if doesn't support latest version
                            <div
                              style={{
                                position: "absolute",
                                paddingLeft: "28px",
                                zIndex: 110,
                              }}
                            >
                              <Tooltip
                                tooltipText={`${getLocaleString("BLOCK-SELECTION/UNSUPPORTED-PAST")} ${
                                  Object.keys(block.validVersions)[Object.keys(block.validVersions).length - 1]
                                }`}
                                textStyleOverrides={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "red",
                                }}
                              >
                                <h2 style={{ backgroundColor: "red", margin: "0" }}>{"!"}</h2>
                              </Tooltip>
                            </div>
                          )}
                        <div className="blockWithIndicator">
                          <BlockImage
                            coloursJSON={coloursJSON}
                            colourSetId={colourSetId}
                            blockId={blockId}
                            onClick={() => {
                              onChangeColourSetBlock(colourSetId, blockId);
                              if (block.presetIndex === "CUSTOM") {
                                this.setState({ lastSelectedCustomBlock: { colourSetId, blockId } });
                              }
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          />
                          {selectedBlocks[colourSetId] === blockId && <div className="selectionLine" />}
                        </div>
                      </Tooltip>
                    </label>
                  ))}
              </div>
            </div>
          ))}
      </React.Fragment>
    );
    return (
      <div className="section blockSelectionDiv">
        {presetsManagement}
        {blockSelection}
        <BlockSelectionAddCustom
          getLocaleString={getLocaleString}
          coloursJSON={coloursJSON}
          onAddCustomBlock={handleAddCustomBlock}
          onDeleteCustomBlock={handleDeleteCustomBlock}
          lastSelectedCustomBlock={lastSelectedCustomBlock}
        />
      </div>
    );
  }
}

export default BlockSelection;
